<!--
* @description 底部组件
* @fileName Footer.vue
* @author liulian
* @date 2023/06/30 09:15:05
-->
<template>
  <div class="footer-dark">
    <div class="footer_container">
      <header class="top flex-row">
        <div class="f_right">
          <div class="logo-box">
            <img class="logo" src="@/assets/images/dnn_logo.png" alt="" />
          </div>
          <div class="r_list flex-row-between">
            <div class="l_item" v-for="(item, index) in lists" :key="index">
              <div class="i_title font-size-16 font-weight-600">
                {{ item.title }}
              </div>
              <div class="i_ls foot-downLoad">
                <template v-for="(i, index1) in item.children">
                  <div
                    :key="index1"
                    class="i_con font-size-14 font-weight-400"
                    :class="{ isCursor: item.title !== 'Business Inquiry' }"
                    @click="openUrl(item.title, i.url)"
                  >
                    {{ i.title }}
                  </div>
                  <!-- <div class="i_con" v-else :key="index1">
                    <DownLoad
                      class="font-size-14 font-weight-400"
                      :class="{ isCursor: item.title !== 'Business Inquiry' }"
                      :btnLabel="i.title"
                      :fileUrl="i.url"
                      btnType="text"
                    />
                  </div> -->
                </template>
              </div>
            </div>
            <div class="l_item">
              <img src="@/assets/images/youtube_ewm.png" class="ewm" alt="" />
            </div>
          </div>
        </div>
      </header>
      <!-- <footer class="copyright font-size-16 font-weight-400">
        <p class="t_p text-align-center">
          版权所有@2018 江苏狄诺尼信息技术有限责任公司
        </p>
        <p class="t_p text-align-center">苏ICP备18062906号</p>
      </footer> -->
    </div>
  </div>
</template>

<script>
import DownLoad from "@/components/DownLoad";
export default {
  name: "Footer",
  components: { DownLoad },
  data() {
    return {
      lists: [
        {
          title: "Products",
          children: [
            {
              title: "Digital Design Software Product Line",
              url: "/digital",
            },
            {
              title: "Intelligent Construction Product Line",
              url: "/intelligent",
            },
            {
              title: "Infrastructure O&M Digital Twin Solution",
              url: "/dtwin",
            },
          ],
        },
        {
          title: "Delauney Academy",
          children: [
            {
              title: "Help Document",
              url: "/download?anchor=manual",
            },
            {
              title: "Software Teaching",
              url: "/academy",
            },
          ],
        },
        {
          title: "Download",
          children: [
            {
              title: "Software Download",
              url: "/download?anchor=software",
            },
            {
              title: "Manual Download",
              url: "/download?anchor=manual",
            },
          ],
        },
        {
          title: "Business Inquiry",
          children: [
            {
              title: "Mr. Yipin Zhang",
            },
            {
              title: "Phone: +65 93524366",
            },
            {
              title: "WhatsApp: +65 93524366",
            },
            {
              title: "Email: zhangyipin@jsdnn.com",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    openUrl(type, url) {
      if (["Products", "Download", "Delauney Academy"].includes(type) && url) {
        this.$uniFun.openInCurrentTab(`${url}`);
      }
    },
  },
};
</script>

<style lang="scss">
.footer-dark {
  width: 100%;
  background: #242424;
  .footer_container {
    width: 1200px;
    margin: 0 auto;
    padding: 45px 0;
    color: #fff;

    .top {
      width: 100%;
      margin: auto;
    }

    .f_right {
      flex: 1;
      .logo-box {
        width: 100%;
        padding-bottom: 24px;
        margin-bottom: 24px;
        border-bottom: 1px solid #d8d8d8;
        .logo {
          width: 200px;
          height: auto;
        }
      }
      .r_list {
        width: 100%;
      }
      .title {
        padding-bottom: 24px;
        border-bottom: 1px solid #d8d8d8;
        margin-bottom: 24px;
      }
      .l_item {
        max-width: 275px;
        .i_title {
          margin-bottom: 14px;
        }
        .width210 {
          width: 210px;
        }
        .i_con {
          color: rgba(255, 255, 255, 0.6);
          margin-bottom: 16px;
          &.isCursor {
            cursor: pointer;
            &:hover {
              color: #0035fb;
              text-decoration: underline;
            }
          }
        }
        .i_con:last-child {
          margin-bottom: unset;
        }
        .l_img {
          width: 120px;
          height: 120px;
        }
        .ewm {
          width: 120px;
          height: auto;
        }
      }
      .l_item:last-child {
        margin-right: unset;
      }
    }
    .copyright {
      color: rgba(255, 255, 255, 0.6);
      margin-top: 48px;
      .t_p:first-child {
        margin-bottom: 12px;
      }
      .i_ls {
        font-family: PingFang SC-Regular, PingFang SC;
      }
    }
    .foot-downLoad .dnn-download-box {
      display: block;
    }
  }
}
</style>
